import type { FC } from "react";

import { QrCodeLottery as UIQrCodeLottery } from "@jti/loyalty/components/QrCodeLottery";

import type { qrCodeLotteryInputs } from "./QrCodeLottery.builder";

type QrCodeLotteryBuilderProps = BuilderComponentProps<typeof qrCodeLotteryInputs>;

export const QrCodeLottery: FC<QrCodeLotteryBuilderProps> = (props) => {
  return <UIQrCodeLottery {...props} />;
};
